import { cn } from '@/lib/cn';
import { avatarColour, initialsOf } from '@/lib/person';

const SIZES = { sm: 'size-8 text-xs', md: 'size-11 text-sm', lg: 'size-16 text-xl' } as const;

export function Avatar({
  name,
  seed,
  size = 'md',
  muted = false,
  className,
}: {
  name: string;
  /** Keeps the colour stable when the name changes (use the username). */
  seed?: string;
  size?: keyof typeof SIZES;
  muted?: boolean;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white',
        SIZES[size],
        className,
      )}
      style={{ backgroundColor: muted ? '#a5aba6' : avatarColour(seed ?? name) }}
    >
      {initialsOf(name)}
    </span>
  );
}
